import React, { useEffect, useState } from "react";
import userService from "../../../../../services/user.service";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useEyeconxStore } from "../../../../../store/eyeconxStore";

const ClinicUserSettings = () => {
  const [isDeleteing, setIsDeleting] = useState(false);

  const [delMsg, setDelMsg] = useState("");

  const [userDeleted, setUserDeleted] = useState(false);

  const { clinicId } = useParams();
  const selecteduser = useEyeconxStore((state) => state.selectedUser);
  const [user, setUser] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [roles, setRoles] = useState();

  useEffect(() => {
    getUserInfoById();
    getRoles();
  }, [selecteduser]);

  const getRoles = () => {
    userService
      .getRoles()
      .then((res) => {
        setRoles(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getUserInfoById = () => {
    //get user info
    userService
      .getUser(selecteduser.clinicId, selecteduser.id)
      .then((res) => {
        console.log("Got User");
        console.log(res.data);
        setUser(res.data);
        reset(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleDelChange = (e) => {
    setDelMsg(e.target.value);
  };
  const deleteUser = (e) => {
    e.preventDefault();
    if (delMsg == "Delete") {
      console.log("Delete Now :" + user.id + " clinic:" + clinicId);
      userService
        .deleteUser(user.id, clinicId)
        .then((res) => {
          setUserDeleted(true);
          
          toast.success("User Deleted.", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        })
        .catch((err) => {
          // setDelError(err)
          toast.error("Error while deleting user.", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          console.log(err);
        });
    } else {
      //setDelError("Please Enter Delete in input box")
      toast.error("Please Enter Delete in inputbox.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const resetPassword = () => {
    userService
      .passwordReset(clinicId, user.id)
      .then((res) => {
        toast.success("Password reset email sent!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .catch((err) => {
        toast.error("Error while sending password reset", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };

  
  const onSubmit = (data, e) => {
    console.log("User Data to update");
    console.log(data);
    let newData = data;
    if (!user.isAuthenticated && data.isAuthenticated) {
      newData = { ...data, secret: "ECXuserx1y1z1" };
    }
    console.log(newData);
    userService
      .updateUser(user.id, clinicId, newData)
      .then((res) => {
        toast.success("User Updated !", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        getUserInfoById();
      })
      .catch((err) => {
        toast.error("Error while updating user", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        console.log(err);
      });
  };
  return (
    <>
      <h5 className="card-title">Edit User</h5>
      <div className="row">
        <div className="col-md-6">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group">
              <label htmlFor="" className="form-label">
                First Name
              </label>
              <input
                type="text"
                className="form-control mb-2"
                aria-describedby="emailHelp"
                {...register("firstName", { required: true })}
                placeholder="First Name"
              />
              {errors.firstName && <p>This is required</p>}
            </div>
            <div className="form-group">
              <label htmlFor="" className="form-label">
                Last Name
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Last Name"
                {...register("lastName", { required: true })}
              />
              {errors.lastName && <p>This is required</p>}
            </div>
            <div className="form-group">
              <label htmlFor="" className="form-label">
                Email
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Email"
                {...register("email", { required: true })}
              />
              {errors.email && <p>This is required</p>}
            </div>
            <div className="form-group">
              <label htmlFor="" className="form-label">
                User Name
              </label>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="User Name"
                {...register("userName", { required: true })}
              />
              {errors.userName && <p>This is required</p>}
            </div>
            <div className="form-group">
              <label htmlFor="exampleInputPassword1" className="form-label">
                Role
              </label>

              <select
                className="form-select"
                {...register("roleId", { required: true })}
              >
                {roles &&
                  roles.map((item) => {
                    return <option value={item.id}>{item.roleName}</option>;
                  })}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="exampleInputPassword1" className="form-label">
                Is Authenticated
              </label>

              <select
                className="form-select"
                {...register("isAuthenticated", { required: true })}
              >
                <option value="0">No</option>
                <option value="1">Yes</option>
              </select>
            </div>
            <div className="text-center mt-2">
              <button className="btn btn-primary me-2" type="submit">
                Update
              </button>
            </div>
          </form>
        </div>
        <div className="col-md-4">
          <div className="d-flex flex-column">
            {user && user.isAuthenticated ? (
              <button
                className="btn btn-success btn-sm mb-2"
                onClick={resetPassword}
              >
                Reset Password Request
              </button>
            ) : (
              ""
            )}
            {user && (
              <button
                className="btn btn-danger btn-sm mb-2"
                onClick={() => setIsDeleting(!isDeleteing)}
              >
                Delete User
              </button>
            )}
            {isDeleteing ? (
              <>
                <div className="form-group p-3 mb-2 text-bg-danger rounded">
                  <label htmlFor="" className="form-label">
                    Enter "Delete" to confirm Delete action
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={handleDelChange}
                  />
                  <button
                    className="btn btn-sm btn-warning mt-2"
                    onClick={deleteUser}
                  >
                    Delete
                  </button>
                </div>
              </>
            ) : (
              ""
            )}
            <div className="card text-bg-info">
              <div className="card-body p-4">
                <h5>Note:</h5>
                <p>
                  {" "}
                  If you selected "isAuthenticated" to "Yes" Default password
                  will be set to "ECXuserx1y1z1". Reset Password request will
                  send user an email to reset password on registered email.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClinicUserSettings;
